import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import type { IconProp } from '@fortawesome/fontawesome-svg-core';
import type { FC } from 'react';

interface TaskTypeOptionLabelProps {
  name: string;
  iconId: string | null;
  color: string | null;
}

export const TaskTypeOptionLabel: FC<TaskTypeOptionLabelProps> = ({
  name,
  iconId,
  color,
}) => (
  <span style={{ display: 'inline-flex', alignItems: 'center', gap: 8 }}>
    {iconId && (
      <FontAwesomeIcon
        icon={iconId as IconProp}
        style={{ color: color || undefined, fontSize: 13, flexShrink: 0 }}
      />
    )}
    {name}
  </span>
);
